import React from 'react';
import { Navbar, Footer } from './components';
import { Home } from './pages';

function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Home />
      </main>
      <Footer />
    </div>
  );
}

export default App;
